export const SCROLLBAR_WIDTH = '12px'
export const SCROLLBAR_HEIGHT = '12px'
